import { useNavigate, useSearch } from '@tanstack/react-router';
import { DashboardCanvas } from '@/components/dashboard/DashboardCanvas';
import { DashboardDateControl } from '@/components/dashboard/DashboardDateControl';
import {
  parseDashboardRouteSearch,
  serializeDashboardRouteFilters,
} from '../../dashboard/dashboardRouteSearch';
import { DashboardMetric, DashboardWidgetWidth } from '../../dashboard/model';
import {
  publisherDashboardInheritedDateScope,
  publisherDashboardDocumentSchema,
} from '../../publisher/dashboard/widgetModel';
import { useAgencyDashboardQuery } from '../dashboardApi';
import { PublisherDashboardWidgetType } from '../../publisher/dashboard/widgetModel';
import { publisherDashboardWidgetRegistry } from '../../publisher/dashboard/widgetRegistry';

const metrics = [
  DashboardMetric.AdImpressions,
  DashboardMetric.Revenue,
  DashboardMetric.Rpm,
  DashboardMetric.AdClicks,
];
const dashboardDocument = publisherDashboardDocumentSchema.parse({
  version: 1,
  widgets: [
    ...metrics.map((metric) => ({
      id: `agency-${metric}`,
      type: PublisherDashboardWidgetType.Metric,
      width: DashboardWidgetWidth.Quarter,
      dateScope: publisherDashboardInheritedDateScope,
      metric,
    })),
    {
      id: 'agency-performance',
      type: PublisherDashboardWidgetType.PerformanceChart,
      width: DashboardWidgetWidth.Full,
      dateScope: publisherDashboardInheritedDateScope,
      metrics,
    },
  ],
});

export function AgencyDashboardPage({ agencyId }: { agencyId: string }) {
  const search = useSearch({ from: '/a/$agencyId' });
  const navigate = useNavigate({ from: '/a/$agencyId' });
  const { range } = parseDashboardRouteSearch(search);
  const overview = useAgencyDashboardQuery(agencyId, range);
  return (
    <main className="page-gutter mx-auto w-full max-w-[1920px] min-w-0 space-y-6 py-5">
      <section className="flex justify-end">
        <DashboardDateControl
          showDayNavigation
          value={range}
          onChange={(next) => {
            void navigate({
              search: serializeDashboardRouteFilters({ range: next }),
              replace: true,
            });
          }}
        />
      </section>
      <DashboardCanvas
        document={dashboardDocument}
        registry={publisherDashboardWidgetRegistry}
        runtime={{
          range,
          overview,
          inventory: { data: undefined, isLoading: false, isError: false },
        }}
      />
    </main>
  );
}
